(function () {
    'use strict';

    angular.module("imApp").factory("emailTemplatesService", [function () {
        let service = {};

        return service;
    }]);
})();
